import Image from 'next/image'
import useOrderItem from '../hooks/useOrderItem'
// import {Fragment} from 'react'
import {Price} from './Price'
import {XIcon} from '@heroicons/react/outline'
import tw from 'twin.macro'
import {useEffect, useRef, useState} from 'react'
import {isMobile} from 'react-device-detect'

interface OrderItemProps {
  shQuantity: any
  states: any
  setOrderItems: any
  // order_items: any
  item: any
  hasPrice: boolean
  showQuantity?: boolean
  clickHandler?: (evt: any) => void
  referenceSection?: string
  proofStatus?: string;
  originalEta?: { minimumDeliveryDate: string | null; maximumDeliveryDate: string | null } | null
  rushedEta?: { minimumDeliveryDate: string | null; maximumDeliveryDate: string | null } | null
  // css?: TwStyle[]
}

export const OrderItem: React.FC<OrderItemProps> = ({
  states,
  shQuantity,
  setOrderItems,
  // order_items,
  item,
  hasPrice,
  showQuantity = true,
  children,
  clickHandler = null,
  referenceSection = 'edit_items',
  proofStatus = null,
  originalEta = null,
  rushedEta = null,
}) => {  
  const {image, scent, crop, flag} = useOrderItem(item)
  const [first, setfirst] = useState(0)
  const proof = item.metadata.find(v => v.key === 'Preview')?.value // PNG-B
  const rawProofStatus = proofStatus ?? item.metadata.find(v => v.key === 'Proof')?.value;
  const effectiveProofStatus = ['accepted', 'mockup', 'subscription', 'reorder'].includes(rawProofStatus) ? 'accepted' : rawProofStatus;  
  const isProofUpdated = effectiveProofStatus === 'accepted' || effectiveProofStatus === 'rejected';
  
  // Hide variant details for Rush Production or Gift Message items in order summary
  const shouldHideVariantDetails = 
    referenceSection === "order_summary" && 
    (item.name?.includes('Rush Production') || item.name?.includes('Gift Message'));
  const isRushProductionItem = item.name?.includes('Rush Production')

  const Quantity = () => (
    <span
      className="item-qty"
      tw="mx-auto font-semibold md:pt-1 inline-flex self-start items-center text-brand leading-none"
    >
      {/*mr-40 */}x{item.quantity}
    </span>
  )

  const formatDate = (date) => {
    if (!date) return 'N/A'
    const [year, month, day] = date.split('-').map(Number)
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    return `${months[month - 1]} ${day}`
  }

  const formatDateRange = (minDate, maxDate) => {
    if (!minDate && !maxDate) return 'N/A'
    if (!minDate) return formatDate(maxDate)
    if (!maxDate) return formatDate(minDate)
    return `${formatDate(minDate)} - ${formatDate(maxDate)}`
  }

  useEffect(() => {
    setOrderItems(states)
  }, [states])

  return (
    <>
      <div className={`d-flex-item ${referenceSection === "refund_section" || referenceSection === "update_items" || referenceSection === "reorder_section" ? 'card-content': ''}`}
      css={[
        // Case 1: reorder_section or order_summary or update_items or (review_proofs without proof update)
        (["reorder_section", "order_summary", "update_items"].includes(referenceSection) ||
          (referenceSection === "review_proofs" && !isProofUpdated))
          ? tw`mt-0 lg:mt-0 md:mt-0`

        // Case 2: refund_section or review_proofs with update
        : (["refund_section"].includes(referenceSection))
          ? tw`mt-6 lg:mt-0 md:mt-0`
        : (["refund_section", "review_proofs"].includes(referenceSection) && isProofUpdated)
          ? tw`mt-6 lg:mt-0 md:mt-0`

        // Fallback
        : null
      ]}


      >
        <div
          className="img-size"
          css={[
            tw`mr-4 flex-shrink-0 relative flex-wrap mb-4 md:mb-0`
          ]}
          style={{fontSize: 0}}
          onClick={clickHandler}
        >
          {image && (
            <img
              tw="border bg-white text-gray-300 object-contain"
              className="border-gray"
              src={image}
              alt=""
            />
          )}
        </div>
        <div tw="" onClick={clickHandler}>
          <h3
            className="order-heading line-item-description"
            css={[
              tw`text-base text-brand font-semibold md:truncate max-w-lg leading-none md:leading-normal`,
            ]}
          >
            {item.name.split(' - ')[0]}{' '}
            {/* {referenceSection !== "order_summary" && ` (${item.quantity})`} */}
          </h3>
          <dl
            css={[tw`mt-1 text-sm text-gray-400`]}
            className="font-w-regular"
          >
            {!shouldHideVariantDetails && (
              <>
                <div className="flex-item item-scent" tw="grid items-center">
                  <dt tw="" className="line-item-description">Scent : <span>{scent}</span></dt>

                </div>
                <div className="flex-item" tw="flex items-center">
                  <dt tw="" className="line-item-description">Crop :&nbsp;
                  {
                    crop == 'Do Not Crop'? "Do Not Crop (we'll keep the photo as is)" : crop
                    // crop != 'Just The Head(s)' && crop != 'Entire Body(s)' && crop != 'Do Not Crop' && crop != 'Just The Car'? 'Other' : crop
                  }
                  </dt>
                </div>
                <div className="flex-item" tw="flex items-center">
                  <dt tw="" className="line-item-description">Photo :</dt>
                  <dd tw="ml-1">
                    <a
                      tw="underline cursor-pointer hover:text-brand"
                      href={image}
                      target="_blank"
                      rel="noreferrer"
                      className="line-item-description"
                    >
                      View
                    </a>
                  </dd>
                </div>
              </>
            )}
            {/* Proof link (Preview) for applicable sections */}
            {proof && (referenceSection === "review_proofs" || referenceSection === "order_summary") && (
              <div className="flex-item" tw="flex items-center">
                <dt tw="" className="line-item-description">Proof :</dt>
                <dd tw="ml-1">
                  <a
                    tw="underline cursor-pointer hover:text-brand"
                    href={proof}
                    target="_blank"
                    rel="noreferrer"
                    className="line-item-description"
                  >
                    Link
                  </a>
                </dd>
              </div>
            )}
            {referenceSection === "order_summary" && isRushProductionItem && (
              <>
                <div className="flex-item" tw="flex items-center flex-nowrap">
                  <dt tw="whitespace-nowrap" className="line-item-description">Original ETA :</dt>
                  <dd tw="ml-1 whitespace-nowrap" className="line-item-description">
                    {formatDateRange(
                      originalEta?.minimumDeliveryDate,
                      originalEta?.maximumDeliveryDate,
                    )}
                  </dd>
                </div>
                <div className="flex-item" tw="flex items-center flex-nowrap">
                  <dt tw="whitespace-nowrap" className="line-item-description">Rushed ETA :</dt>
                  <dd tw="ml-1 whitespace-nowrap" className="line-item-description">
                    {formatDateRange(
                      rushedEta?.minimumDeliveryDate,
                      rushedEta?.maximumDeliveryDate,
                    )}
                  </dd>
                </div>
              </>
            )}
            {!shouldHideVariantDetails && !shQuantity && (
              <div className="flex-item" tw="flex items-center">
                <dt tw="" className="line-item-description">Quantity :</dt>
                <dd tw="ml-1" className="line-item-description">{item.quantity}</dd>
              </div>
            )}
          </dl>
        </div>
      </div>
      {referenceSection === "order_summary" && (
        <>
        {showQuantity && <Quantity />}
        {hasPrice ? (
          <span
            className="item-price"
            css={[
              tw`leading-none font-semibold place-self-start md:pt-1`,
              !showQuantity && tw`ml-auto md:-mt-0.5`,
            ]}
          >
            <Price>${item.price}</Price>
          </span>
        ) : null}
        </>
      )}

      {children}
    </>
  )
}
